export default "__VITE_ASSET__CgPrMFfr__"